export interface ApiBaseResponse {
  success: boolean;
  error?: string | Error;
}

export function mapResponseErrorToMessage(error: ApiBaseResponse['error']): string | undefined {
  if (typeof error === 'string') {
    return error;
  }

  return error?.message;
}
